import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import TableError from './TableError';

const TableBody = (props) => {
    const Row = props.rowComponent || TableRow;

    return (
        <tbody>
        {!props.children.length
            ? <TableError
                colSpanGetter={props.colSpanGetter}
                size={props.columns.length}
            >
                {props.errorMessage}
            </TableError>
            : props.children.map((row, index) =>
                <Row
                    key={index}
                    columns={props.columns}
                    {...props.rowProps}
                >
                    {row}
                </Row>
            )
        }
        </tbody>
    );
};

TableBody.propTypes = {
    rowComponent: PropTypes.object,
    rowProps: PropTypes.object,
    children: PropTypes.array,
    columns: PropTypes.array,
    errorMessage: PropTypes.string,
    colSpanGetter: PropTypes.func
};

export default TableBody;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableBody.js